// Minimal, chrome-free layout for the business-facing add-account flow, sized to be hosted
// directly as an <iframe> in a consumer app (recommended iframe size: 460x640) that shows
// nothing but the funding-source widget itself — no branding, no copy, no wrapper box when
// there's nothing to show (Plaid's own overlay is the only UI most of the time).
import type { ReactNode } from 'react';

import { Icon } from '@/components/ds';

export function AccountShell({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        width: 460,
        minHeight: 640,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 24,
        background: '#fff',
      }}
    >
      {children}
    </div>
  );
}

export function AccountError({ title, message }: { title: string; message: string }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: '50%',
          background: 'var(--critical-soft, #fdecec)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <Icon name="warning" size={26} color="var(--critical, #d23535)" />
      </div>
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5 }}>{message}</div>
    </div>
  );
}
